import './assets/css/components.sass'

import landingAppsInfo from './assets/maps/landingAppsInfo.json'

// const BaseSelect = () => import('./components/multiselect/BaseSelect.vu')
import BaseSelect from './components/multiselect/BaseSelect.vue'
import BaseAccordion from './components/BaseAccordion.vue'
import BaseButton from './components/buttons/BaseButton.vue'
import BaseBackButton from './components/buttons/BaseBackButton.vue'

import Calendar from './components/calendar/Calendar.vue'
import CalendarInput from './components/calendar/CalendarInput.vue'
import CalendarRange from './components/calendar/CalendarRange.vue'
import CalendarMobileRange from './components/calendar/CalendarMobileRange.vue'

import DatePicker from './components/date-picker/DatePicker.vue'
import DatePickerDesktop from './components/date-picker/DatePickerDesktop.vue'

import BaseInput from './components/inputs/BaseInput.vue'
import BaseInputCounter from './components/inputs/BaseInputCounter.vue'
import BaseQuestionInputWrap from './components/inputs/BaseQuestionInputWrap.vue'
import BaseInputCounterNew from './components/inputs/BaseInputCounterNew.vue'
import BaseInputPhone from './components/inputs/BaseInputPhone'
import BaseClearInput from './components/inputs/BaseClearInput'
import BasePromocodeInput from './components/inputs/BasePromocodeInput'
import PromoInputWithApply from './components/inputs/PromoInputWithApply'

import BaseError from './components/errors/BaseError'
import CantProvideError from './components/errors/CantProvideError'

import ContactUs from './components/need-help/ContactUs'
import ContactUsPopup from './components/need-help/ContactUsPopup'

import BaseForm from './components/BaseForm.vue'
import BaseFormLayout from './components/BaseFormLayout.vue'
import BaseNewForm from './components/BaseNewForm.vue'
import BaseNewQuote from './components/quote/BaseNewQuote.vue'

import BaseInsuranceSuccess from './components/BaseInsuranceSuccess.vue'
import BaseIstimara from './components/BaseIstimara.vue'
import BaseNotFound from './components/BaseNotFound.vue'
import Reminder from './components/Reminder.vue'
import SslProtectionReminder from './components/SslProtectionReminder.vue'
import Loader from './components/Loader.vue'
import Logo from './components/Logo.vue'
import RenewLogo from './components/RenewLogo.vue'
import BaseLanding from './components/landing/BaseLanding.vue'
import BaseLandingPromo from './components/landing/BaseLandingPromo.vue'
import BaseLandingHoliday from './components/landing/BaseLandingHoliday.vue'

import LandingFaqs from './components/landing/LandingFaqs.vue'
import LandingRating from './components/landing/LandingRating.vue'
import LandingStepsToClaim from './components/landing/LandingStepsToClaim.vue'
import LandingBoost from './components/landing/LandingBoost.vue'
import LandingHeader from './components/landing/LandingHeader.vue'
import AppHeader from './components/header/AppHeader.vue'
import AppFooter from './components/footer/AppFooter.vue'
import LandingFooter from './components/landing/LandingFooter.vue'
import LandingFooterNew from './components/landing/LandingFooterNew.vue'
import LandingFeedbackHolder from './components/landing/LandingFeedbackHolder.vue'

import QuoteInclusive from './components/quote/QuoteInclusive'
import QuoteInsuredList from './components/quote/QuoteInsuredList'
import QuoteInsuredMember from './components/quote/QuoteInsuredMember'
import QuoteInsuredMemberPab from './components/quote/QuoteInsuredMemberPab'
import QuoteInsuredItem from './components/quote/QuoteInsuredItem'
import QuoteAdditionalBenefits from './components/quote/QuoteAdditionalBenefits'
import QuoteCheckout from './components/quote/QuoteCheckout'
import QuoteCheckoutSimple from './components/quote/QuoteCheckoutSimple'
import QuoteAdditionals from './components/quote/QuoteAdditionals'
import QuoteTravelDates from './components/quote/QuoteTravelDates'
import QuoteInformation from './components/quote/QuoteInformation'
import RenewInformation from './components/quote/RenewInformation'
import QuoteRenewInformation from './components/quote/QuoteRenewInformation'
import QuotePolicyOwner from './components/quote/QuotePolicyOwner'
import BaseQuote from './components/quote/BaseQuote'
import QuotePolicyHolder from './components/quote/QuotePolicyHolder'
import QuoteMotorInfo from './components/quote/QuoteMotorInfo'
import PreQuote from './components/quote/PreQuote'
import MemberAdditionalCover from './components/additional-members/MemberAdditionalCover'
import QuoteReferenceNumber from './components/QuoteReferenceNumber.vue'

import UserIdForm from './components/user-forms/UserIdForm.vue'
import UserNameForm from './components/user-forms/UserNameForm.vue'
import UserContactsForm from './components/user-forms/UserContactsForm.vue'

import CookieNotice from './components/CookieNotice.vue'
import WelcomeBar from './components/header/banners/WelcomeBar.vue'

import WizardStep from './components/WizardStep.vue'
import wizardMixin from './mixins/wizardMixin.js'
import wizardStepMixin from './mixins/wizardStepMixin.js'

import SelectPlan from './components/SelectPlan.vue'
import BasePopupWrapper from './components/popups/BasePopupWrapper.vue'
import SelectPlanPopup from './components/popups/BaseSelectPlanPopup.vue'
import TplPopup from './components/popups/contentExamples/TplPopup.vue'
import ComprehensivePopup from './components/popups/contentExamples/ComprehensivePopup.vue'
import ComplatePopup from './components/popups/contentExamples/ComplatePopup.vue'
import AdultsDisplay from './components/landing/AdultsDisplay.vue'

import QuoteApplePayButton from './components/quote/QuoteApplePayButton'

import InboundInfo from './components/InboundInfo'

import CarBanner from './components/landing/CarBanner'

import Wizard from './wizard/Wizard.js'
import dataLayer from './libs/dataLayer.js'
// utils
import { formatDate, formatDateWithoutTz, baseFormatDate } from './utils/formatDate'
import { onInputName } from './utils/onInputName'
// locales
import ThreeMonthsCampaign from './components/campaigns/ThreeMonthsCampaign/ThreeMonthsCampaign.vue'
const qicLocales = {
  ar: require('./locales/import/ar.json'),
  en: require('./locales/import/en.json')
}
export {
  BaseSelect,
  BaseAccordion,
  BaseButton,
  BaseBackButton,
  BaseInput,
  BaseInputCounter,
  BaseInputCounterNew,
  BaseInputPhone,
  BaseClearInput,
  BaseQuestionInputWrap,
  BasePromocodeInput,
  PromoInputWithApply,
  BaseForm,
  BaseNewForm,
  BaseNewQuote,
  BaseFormLayout,
  BaseInsuranceSuccess,
  BaseIstimara,
  BaseNotFound,
  BaseError,
  CantProvideError,
  Calendar,
  CalendarInput,
  CalendarRange,
  CalendarMobileRange,
  DatePicker,
  DatePickerDesktop,
  Reminder,
  SslProtectionReminder,
  Loader,
  Logo,
  RenewLogo,
  ContactUs,
  ContactUsPopup,
  CookieNotice,
  WelcomeBar,
  UserIdForm,
  UserNameForm,
  UserContactsForm,
  BaseLanding,
  BaseLandingPromo,
  BaseLandingHoliday,
  LandingFeedbackHolder,
  LandingFaqs,
  LandingRating,
  LandingStepsToClaim,
  LandingBoost,
  LandingHeader,
  AppHeader,
  AppFooter,
  LandingFooter,
  LandingFooterNew,
  QuoteInclusive,
  QuoteInsuredList,
  QuoteInsuredMember,
  QuoteInsuredMemberPab,
  QuoteInsuredItem,
  QuoteCheckout,
  QuoteCheckoutSimple,
  QuoteAdditionals,
  QuoteAdditionalBenefits,
  QuoteTravelDates,
  QuoteInformation,
  RenewInformation,
  QuoteRenewInformation,
  QuotePolicyOwner,
  QuoteMotorInfo,
  QuoteApplePayButton,
  QuoteReferenceNumber,
  BaseQuote,
  QuotePolicyHolder,
  PreQuote,
  MemberAdditionalCover,
  landingAppsInfo,
  qicLocales,
  wizardMixin,
  wizardStepMixin,
  WizardStep,
  SelectPlan,
  TplPopup,
  BasePopupWrapper,
  ComprehensivePopup,
  ComplatePopup,
  SelectPlanPopup,
  AdultsDisplay,
  Wizard,
  formatDate,
  formatDateWithoutTz,
  baseFormatDate,
  dataLayer,
  InboundInfo,
  onInputName,
  CarBanner,
  ThreeMonthsCampaign
}
